import * as modalComponet from './modal';

// 公開期間の開始日時と終了日時に必須ラベルを追加
export function addPublishedPeriodLabelRequired () {
  let publishedPeriodTypes = document.querySelectorAll('input[name$="[published_period_type]"]');
  for (var publishedPeriodType in publishedPeriodTypes) {
    let object = publishedPeriodTypes[publishedPeriodType];
    if (object.checked) {
      changeDisabledPublishedPeriodType(object);
    }
  }
}

// 募集期間の開始日時と終了日時に必須ラベルを追加
export function addRecruitmentPeriodLabelRequired () {
  let recruitmentPeriodTypes = document.querySelectorAll('input[name$="[recruitment_period_type]"]');
  for (var recruitmentPeriodType in recruitmentPeriodTypes) {
    let object = recruitmentPeriodTypes[recruitmentPeriodType];
    if (object.checked) {
      changeDisabledRecruitmentPeriodType(object);
    }
  }
}

// 公開期間の区分を選択
export function selectPublishedPeriodType () {
  $('input[name$="[published_period_type]"]').change(function () {
    changeDisabledPublishedPeriodType(this);
  })
}

// 募集期間の区分を選択
export function selectRecruitmentPeriodType () {
  $('input[name$="[recruitment_period_type]"]').change(function () {
    changeDisabledRecruitmentPeriodType(this);
  })
}

// 古い記事で外部サイトへのアクセスを遮断
export function blockOldLink () {
  // 遮断するかのフラグを取得
  let oldFlgElement = document.querySelector('#old_flg');

  if (!!oldFlgElement) {
    let oldFlg = oldFlgElement.value;

    if (oldFlg == 'false') {
      return
    }

    // 内容の中にあるリンクを全て取得
    let oldLinkElements = document.querySelectorAll('div.tab-content a');

    for (let i = 0; i < oldLinkElements.length; i++) {
      let href = oldLinkElements[i].href;
      let url = new URL(href);

      // リンク先が外部サイトか判定
      if (url.hostname != 'www.shimane-ikiiki.jp') {
        // クラスを追加
        oldLinkElements[i].classList.add('old_article');
        // リンクを無効化
        oldLinkElements[i].href = "javascript:void (0)";
        oldLinkElements[i].target = "_self";

        // イベントリスナーを登録
        oldLinkElements[i].addEventListener('click', function(event) {
          // 空のmodal要素を準備
          var oldArticleModalBodyElement = document.createElement('div');
          // modalのbodyの文章
          var bodyElement = document.createElement("p");
          bodyElement.innerHTML = "外部サイトへのアクセスが検出されました。<br /><br />";
          bodyElement.innerHTML += "本記事は、掲載期間外となっており掲載された内容が古いため、<br />";
          bodyElement.innerHTML += "安全を考慮し、外部サイトへのアクセスを禁止いたしております。<br />";
          bodyElement.innerHTML += "ご了承の程、よろしくお願い申し上げます。<br /><br />";
          bodyElement.innerHTML += "※本サイトに掲載されている、外部サイトへのアクセスはご自身の責任の元、行ってください。";
          oldArticleModalBodyElement.appendChild(bodyElement);

          // 空のmodalに渡すoptionを設定
          var options = {
            header: {
              title: "外部サイトへのアクセス"
            },
            body: {
              contents: oldArticleModalBodyElement
            }
          };
          // modalElementを準備
          var oldArticleModalElement = modalComponet.blankModalElement(options);
          if (!!oldArticleModalElement) {
            var modalElement = document.querySelector('.modal');
            if (!!modalElement) {
              modalElement.replaceWith(oldArticleModalElement);
            } else {
              document.body.append(oldArticleModalElement);
            }
          }

          modalComponet.modalOpen();
        });
      }
    }
  }
}

// 公開期間の区分の選択によって開始と終了の入力を制限する
function changeDisabledPublishedPeriodType (element) {
  // 開始日時
  let startElement = document.getElementById('published_start_at')
  let startSelect = startElement.children
  // 終了日時
  let endElement = document.getElementById('published_end_at')
  let endSelect = endElement.children

  if (element.value == 'no_period_setting') {
    // 開始日時入力不可
    changeDisabled(startSelect, true)
    // 終了日時入力不可
    changeDisabled(endSelect, true)
    // 開始日時の必須を解除
    startElement.parentElement.querySelector('label').classList.remove('required');
    // 終了日時の必須を解除
    endElement.parentElement.querySelector('label').classList.remove('required');
  } else if (element.value == 'only_start_at') {
    // 開始日時入力可
    changeDisabled(startSelect, false)
    // 終了日時入力不可
    changeDisabled(endSelect, true)
    // 開始日時に必須を追加
    startElement.parentElement.querySelector('label').classList.add('required');
    // 終了日時の必須を解除
    endElement.parentElement.querySelector('label').classList.remove('required');
  } else if (element.value == 'full_period_setting') {
    // 開始日時入力可
    changeDisabled(startSelect, false)
    // 終了日時入力可
    changeDisabled(endSelect, false)
    // 開始日時に必須を追加
    startElement.parentElement.querySelector('label').classList.add('required');
    // 終了日時に必須を追加
    endElement.parentElement.querySelector('label').classList.add('required');
  }
}

// 募集期間の区分の選択によって開始と終了の入力を制限する
function changeDisabledRecruitmentPeriodType (element) {
  // 開始日時
  let startElement = document.getElementById('recruitment_start_at')
  let startSelect = startElement.children
  // 終了日時
  let endElement = document.getElementById('recruitment_end_at')
  let endSelect = endElement.children

  if (element.value == 'setting') {
    // 開始日時入力可
    changeDisabled(startSelect, false)
    // 終了日時入力可
    changeDisabled(endSelect, false)
    // 開始日時に必須を追加
    startElement.parentElement.querySelector('label').classList.add('required');
    // 終了日時に必須を追加
    endElement.parentElement.querySelector('label').classList.add('required');
  } else if (element.value == 'any_time') {
    // 開始日時入力不可
    changeDisabled(startSelect, true)
    // 終了日時入力不可
    changeDisabled(endSelect, true)
    // 開始日時の必須を解除
    startElement.parentElement.querySelector('label').classList.remove('required');
    // 終了日時の必須を解除
    endElement.parentElement.querySelector('label').classList.remove('required');
  }
}

// elements内の要素全ての表示を変更
function changeDisabled (elements, bool){
  if (!!elements) {
    for (let i = 0; i < elements.length; i++) {
      elements[i].disabled = bool;
    }
  }
}
